<template>
  <ul class="queries-list-item-list">
    <queriesListItem v-for="(query, index) in resolvedQueries" :key="`list-query-${index}`" :query="query" />
  </ul>
</template>

<script>
import queriesListItem from './QueriesListItem.vue';
import { queriesDisplayOrder } from '../../../../config/bool-const';

export default {
  name: "QueriesList",

  props: {
    queries: {
      type: [String, Object],
      default: () => {}
    }
  },

  computed: {
    queryIsString() { return Object.prototype.toString.call(this.queries) === "[object String]" },

    // A single query from Group
    query() { return this.queryIsString && [{
      query: this.queries
    }] },

    sortedQueries() {
      return queriesDisplayOrder
        .map(key => ({[key]: this.queries[key]})).filter(item => item)
        .filter(item => item[Object.keys(item)] )
    },

    resolvedQueries() { return this.queryIsString ? this.query : this.sortedQueries }

  },

  components: {
    queriesListItem,
  }
}
</script>